// Landing page at the app root ('/'), wrapped in the no-side-nav AppLayout.
import { RouteObject } from 'react-router-dom';
import AppLayout from 'src/components/app/AppLayout';
import { RouteErrorBoundary } from 'src/components/ErrorBoundary';
import HomePage from 'src/components/pages/home/HomePage';
import { ROUTES } from 'src/routes/home/routes';

export const homeRouteGroups: RouteObject[] = [
  {
    element: <AppLayout />,
    children: [
      {
        path: ROUTES.HOME,
        element: <HomePage />,
        errorElement: <RouteErrorBoundary />,
      },
    ],
  },
];
